import type { RebookEligibilityType } from './models';
import { RebookEligibility } from './models';
import ChangeableOrderByCustomer from './ChangeableOrderByCustomer';
import OrderChangeabilityContactUs from './OrderChangeabilityContactUs';
import OrderChangeabilityContactAirline from './OrderChangeabilityContactAirline';
import OrderChangeabilityNotAvailable from './OrderChangeabilityNotAvailable';

interface OrderChangeabilityContentProps {
  rebookEligibilityType: RebookEligibilityType;
  shouldShowContactMethods: boolean;
  shouldShowChangeTripButton: boolean;
}

const OrderChangeabilityContent = ({
  rebookEligibilityType,
  shouldShowContactMethods,
  shouldShowChangeTripButton,
}: OrderChangeabilityContentProps) => {
  switch (rebookEligibilityType) {
    case RebookEligibility.CHANGE_BY_CUSTOMER:
    case RebookEligibility.CHANGE_BY_CUSTOMER_ANCILLARIES:
    case RebookEligibility.CHANGE_FLEXIBLE_TICKET_YOURSELF:
      return (
        <ChangeableOrderByCustomer
          rebookEligibilityType={rebookEligibilityType}
          shouldShowChangeTripButton={shouldShowChangeTripButton}
          shouldShowContactMethods={shouldShowContactMethods}
        />
      );
    case RebookEligibility.CHANGE_BY_ETG:
    case RebookEligibility.CHANGE_PNR_WITH_ETG:
    case RebookEligibility.CHANGE_FLEXIBLE_TICKET:
    case RebookEligibility.CHANGE_BY_ETG_IF_POSSIBLE:
    case RebookEligibility.CHANGE_NOT_CONFIRMED:
    case RebookEligibility.CHANGE_NOT_OPEN_TICKET:
    case RebookEligibility.CHANGE_BY_ETG_ANCILLARIES:
    case RebookEligibility.CHANGE_UNKNOWN:
      return (
        <OrderChangeabilityContactUs
          rebookEligibilityType={rebookEligibilityType}
          shouldShowContactMethods={shouldShowContactMethods}
        />
      );
    case RebookEligibility.CHANGE_BY_AIRLINE:
    case RebookEligibility.CHANGE_SHORT_DEPARTURE:
    case RebookEligibility.CHANGE_EXCHANGED_BY_AIRLINE:
      return <OrderChangeabilityContactAirline rebookEligibilityType={rebookEligibilityType} />;
    case RebookEligibility.CHANGE_NOT_AVAILABLE:
      return <OrderChangeabilityNotAvailable />;
    default:
      return null;
  }
};

export default OrderChangeabilityContent;
